import { validators } from "utils";
import * as Yup from "yup";

export interface ICreatePremiumServiceInterestFormSchema {
  assigneeInfo: {
    assignee: any;
  },
  extraInfo: {
    estimatedResolutionDate: string
    priority: string;
    notes: string;
  };
  interestInfo: {
    district: string;
    customer: {
      fullName: string;
      phoneNumber: string;
      digitalAddress: string;
    };
    generateRAT: boolean;
  }
}

export const PREMIUM_SERVICE_INTEREST_STATUS_BADGE_OPTIONS = {
  Pending: "bg-amber-100 text-amber-800",
  AppointmentConfirmed: "bg-green-100 text-green-800",
  Cancelled: "bg-red-100 text-red-800",
};

export const CreatePremiumServiceInterestInterestInfoSchema = Yup.object({
  district: Yup.string(),
  customer: Yup.object({
    fullName: Yup.string().required("Full name is required"),
    phoneNumber: Yup.string()
      .matches(validators.PhoneNumberRegex, "Kindly enter a valid phone number")
      .required("Phone number is required"),
    digitalAddress: Yup.string()
      .matches(validators.GhanaPostRegex, "Kindly enter a valid GhanaPost Address")
      .required("Digital address is required"),
  }),
  generateRAT: Yup.boolean().required("Kindly indicate if you want to generate a RAT"),
});

export const getCreatePremiumServiceInterestInitialValues = (
  districtId?: string,
): ICreatePremiumServiceInterestFormSchema => ({
  assigneeInfo: {
    assignee: null,
  },
  extraInfo: {
    estimatedResolutionDate: "",
    priority: "",
    notes: "",
  },
  interestInfo: {
    district: districtId || "",
    customer: {
      fullName: "",
      phoneNumber: "",
      digitalAddress: "",
    },
    generateRAT: false,
  },
});
